module.exports = __webpack_public_path__ + "static/media/SAP_Template.c9360a1d.xlsx";